export function inventoryDiscrepancyAssigneePatchMessage(
  assignedToUserId: string | null | undefined,
  currentUserId: string,
): string | null {
  if (assignedToUserId === undefined) {
    return null;
  }
  if (assignedToUserId === null) {
    return "Assignee cleared.";
  }
  if (inventoryDiscrepancyUserIdsMatch(assignedToUserId, currentUserId)) {
    return "You are now assigned to this request.";
  }
  return "Assignee updated.";
}

export function inventoryDiscrepancyUserIdsMatch(left: string, right: string): boolean {
  return left.trim().toLowerCase() === right.trim().toLowerCase();
}
